import { YearQuery } from "../common/filter";
import GallerySliderMobile from "../common/slider-mobile";
import { usePerformance } from "../contexts/performance-context";
import { PerformanceSectionProps } from "../types/common";

export default function MobileView({ data }: { data: PerformanceSectionProps }) {
  const { loading, performances, setPageNo, loadingMore, year, type, setYear, setType } =
    usePerformance();

  return (
    <div className="lg:hidden">
      <GallerySliderMobile
        yearQuery={YearQuery.PERFORMANCE_YEAR}
        data={data}
        loading={loading}
        items={performances}
        setPageNo={setPageNo}
        loadingMore={loadingMore}
        year={year}
        type={type}
        setYear={setYear}
        setType={setType}
      />
    </div>
  );
}
